const dataDisplayCtor = require("./dataDisplayCtor");
const TooltipAdmin = require("../../Tooltip/A");

const adminCtor = (props = {}) => dataDisplayCtor({...props, tooltipComponent: TooltipAdmin});

module.exports = adminCtor;
